module.exports = __webpack_public_path__ + "edf41ae633d2d22594c6cfa51d664558.pdf";